module.exports = __webpack_public_path__ + "static/media/environment.9d75366e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/environment.svg
// module id = 273
// module chunks = 0